import { useMemo } from 'react';

export default function usePercentage(count: number, total: number): string {
  const percentage: string = useMemo(
    () => (total ? `${Math.floor((count / total) * 100)}%` : '0%'),
    [count, total],
  );
  return percentage;
}
